import React from 'react';

import { RoomType } from '$/GraphQL/schema/types';
import { ExitRoomParts } from './ExitRoomParts';
import { PostExitRoomParts } from './PostExitRoomParts';
import { RoomPartsBase } from './RoomPartsBase';
import { WaitingRoomsParts } from './WaitingRoomParts';
import { PresentationRoomParts } from './PresentationRoomParts';

export function useRoomArea(type: RoomType): RoomPartsBase {
  return React.useMemo(() => {
    switch (type) {
      case RoomType.PreWaiting:
      case RoomType.Waiting: {
        return new WaitingRoomsParts();
      }
      case RoomType.Presentation: {
        return new PresentationRoomParts();
      }
      case RoomType.Exit: {
        return new ExitRoomParts();
      }
      case RoomType.PostExit: {
        return new PostExitRoomParts();
      }
    }
  }, [type]);
}
